import React from 'react';
import { Phone, Mail, Clock, MapPin, Instagram } from 'lucide-react';
import { companyInfo } from '../data/mock';
import { Button } from './ui/button';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      {/* CTA Banner */}
      <div className="bg-[#ECEC75] py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Locked Out Right Now?
          </h2>
          <p className="text-xl text-gray-700 mb-6">
            Don't panic! We're available 24/7 to help you.
          </p>
          <a href={companyInfo.phoneLink}>
            <Button className="bg-black hover:bg-gray-800 text-white px-10 py-6 text-2xl font-bold flex items-center gap-3 mx-auto transition-all hover:scale-105 shadow-2xl">
              <Phone className="w-7 h-7 animate-pulse" />
              CALL US NOW
            </Button>
          </a>
          <p className="mt-4 text-gray-800 text-lg font-semibold">{companyInfo.phone}</p>
        </div>
      </div>

      {/* Footer Content */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-12">
            {/* Company Info */}
            <div className="md:col-span-2">
              <img 
                src={companyInfo.logo} 
                alt="Lockout Bros Logo" 
                className="h-24 w-auto mb-6"
              />
              <p className="text-gray-400 mb-6 max-w-md">
                Professional emergency lockout services across the Greater Toronto Area. 
                Fast, reliable, and available 24/7 when you need us most.
              </p>
              <div className="flex items-center gap-2 text-[#ECEC75] text-xl font-bold">
                Only {companyInfo.serviceFee} Service Call Fee
              </div>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-lg font-bold mb-6">Contact Us</h3>
              <div className="space-y-4">
                <a href={companyInfo.phoneLink} className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors">
                  <Phone className="w-5 h-5 text-[#ECEC75]" />
                  {companyInfo.phone}
                </a>
                <a href={`mailto:${companyInfo.email}`} className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors">
                  <Mail className="w-5 h-5 text-[#ECEC75]" />
                  {companyInfo.email}
                </a>
                <a href={companyInfo.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors">
                  <Instagram className="w-5 h-5 text-[#ECEC75]" />
                  @thelockoutbros
                </a>
              </div>
            </div>

            {/* Hours */}
            <div>
              <h3 className="text-lg font-bold mb-6">Hours</h3>
              <div className="space-y-4">
                <div className="flex items-center gap-3 text-gray-400">
                  <Clock className="w-5 h-5 text-[#ECEC75]" />
                  <span>24 Hours / 7 Days</span>
                </div>
                <div className="flex items-center gap-3 text-gray-400">
                  <MapPin className="w-5 h-5 text-[#ECEC75]" />
                  <span>All GTA Locations</span>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-500">
            <p>&copy; {currentYear} Lockout Bros Emergency Services. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
